import {
  CreateBatchRelativeInsightsParams,
  CreateBatchRelativeInsightsResponse,
} from './batchRelativeInsightsInterfaces';
import {
  CreateObituaryParserParams,
  CreateObituaryParserResponse,
} from './obituaryParserInterfaces';
import {
  CreatePersonReportSummaryParams,
  CreatePersonReportSummaryResponse,
} from './personReportSummaryInterfaces';
import {
  CreateRelativeInsightsParams,
  CreateRelativeInsightsResponse,
} from './relativeInsightsInterfaces';
import {
  CreateSmartSearchV1Params,
  CreateSmartSearchV1Response,
} from './smartSearchV1Interfaces';
import {
  type CreateTimezoneAndCoordinatesParams,
  type CreateTimezoneAndCoordinatesResponse,
} from './timezoneAndCoordinatesInterfaces';

export const userCategoryTypes = ['buy', 'sell', 'own'] as const;
export type VehicleSmartInsightUserCategoryType =
  typeof userCategoryTypes[number];

export interface CreateVehicleSmartInsightParams {
  mileage?: number | null;
  year?: number | null;
  make?: string | null;
  model?: string | null;
  market_value?: number | null;
  accidents?: number | null;
  damages?: number | null;
  salvages?: boolean | null;
  thefts?: number | null;
  owners?: number | null;
  recalls?: number | null;
  title_brands?: number | null;
}

export interface VehicleSmartInsightsTip {
  header: string;
  detail: string;
}

export interface VehicleSmartInsightUserCategory {
  categoryType: VehicleSmartInsightUserCategoryType;
  rank: number;
  justification: string;
  tips: VehicleSmartInsightsTip[];
}

export type VehicleSmartInsightUserCategories = {
  [key in VehicleSmartInsightUserCategoryType]: VehicleSmartInsightUserCategory;
};

export interface VehicleSmartInsightData {
  historyBasedValue: number;
  userCategories: VehicleSmartInsightUserCategories;
  error: string;
}

export interface CreateVehicleSmartInsightResponse {
  data: VehicleSmartInsightData;
  date: Date;
}

export interface LLMRequestsInterface {
  createVehicleSmartInsight: (
    token: string,
    params: CreateVehicleSmartInsightParams
  ) => Promise<CreateVehicleSmartInsightResponse>;
}

export interface LLMRequestsPersonInterface {
  createPersonReportSummary: (
    token: string,
    params: CreatePersonReportSummaryParams,
    errorHandler?: (error: Response) => Promise<unknown | void>
  ) => Promise<CreatePersonReportSummaryResponse>;
  createRelativeInsight: (
    token: string,
    params: CreateRelativeInsightsParams
  ) => Promise<CreateRelativeInsightsResponse>;
  createBatchRelativeInsight: (
    token: string,
    params: CreateBatchRelativeInsightsParams
  ) => Promise<CreateBatchRelativeInsightsResponse>;
  createObituaryParser: (
    token: string,
    params: CreateObituaryParserParams
  ) => Promise<CreateObituaryParserResponse>;
}

export interface ReportSmartInsightsLocalStorageData {
  [key: string]: CreateVehicleSmartInsightResponse;
}

export interface LLMRequestsSmartSearchV1 {
  createSmartSearchV1: (
    token: string,
    params: CreateSmartSearchV1Params
  ) => Promise<CreateSmartSearchV1Response>;
  createPersonSmartSearchV1: (
    token: string,
    params: CreateSmartSearchV1Params
  ) => Promise<CreateSmartSearchV1Response>;
  createVehicleSmartSearchV1: (
    token: string,
    params: CreateSmartSearchV1Params
  ) => Promise<CreateSmartSearchV1Response>;
}

export interface LLMRequestsUtilsInterface {
  createTimezoneAndCoordinates: (
    token: string,
    params: CreateTimezoneAndCoordinatesParams
  ) => Promise<CreateTimezoneAndCoordinatesResponse>;
}
